import React, { useRef, useEffect, useState } from 'react'
import Spinner from '../Spinner/Spinner'
import { Box } from '@mui/material'

const classes = {
    loadingComponent: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
}

const LoadingComponent = () => {
    const [size, setSize] = useState(0)
    const ref = useRef()
    const innerWidth = typeof window !== 'undefined' ? window.innerWidth : 0
    useEffect(() => {
        if (ref.current) {
            const { clientHeight: height, clientWidth: width } = ref.current
            setSize(Math.min(height * 0.6, width * 0.6, 64))
        }
    }, [ref, innerWidth])

    return (
        <Box ref={ref} sx={classes.loadingComponent}>
            <Spinner size={size} />
        </Box>
    )
}

export default LoadingComponent
